import { render } from "./TaskSortPopup.vue?vue&type=template&id=60e743c3&scoped=true"
import script from "./TaskSortPopup.vue?vue&type=script&lang=js"
export * from "./TaskSortPopup.vue?vue&type=script&lang=js"

import "./TaskSortPopup.vue?vue&type=style&index=0&id=60e743c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e743c3"]])

export default __exports__